const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 500, itemsToShow: 3 },
  { width: 768, itemsToShow: 3 },
  { width: 1200, itemsToShow: 3 },
]

export { breakPoints }
